// extracted by mini-css-extract-plugin
export default {"wrapper":"PieChart_wrapper__I0Yr2","centerData":"PieChart_centerData__Q2duN","tooltip":"PieChart_tooltip__n5FuO"};